import ToolBase from '../basic';
import DEFINE from '../define';

export default class LineFullUp extends ToolBase {

    name = DEFINE.TOOLS.LINE_FULL_UP;

    target = null;

    constructor(parent) {
        super(parent);
    }

    mouseUp(o) {
        if (!this.target || !o.target) return;

        if (this.target.tag == o.target.tag) {
            let setting = this.parent.getDrawColor();

            o.target.set({
                stroke: setting.fill
            })

            this.canvas.renderAll();

            this.parent.addHistory();
        }
    }

    mouseDown(o) {
        this.target = o.target;

        if (o.target) {
            this.canvas.discardActiveObject(o.target);
        }
    }
}